<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">กู้คืนรหัสผ่านของคุณ</h4>
                                  <p>โปรดป้อนเลขประจําตัวประชาชนของคุณและเราจะส่งคำแนะนำเกี่ยวกับวิธีรีเซ็ตรหัสผ่านของคุณไปยังอีเมลที่ทำการลงลงทะเบียนไว้ หากไม่สามารถเข้าอีเมลดังกล่าวได้กรุณาดาวน์โหลดแบบฟอร์มด้านล่างเพื่อดำเนินการแก้ไขอีเมล <a @click="onDownloadFormResetEmailClick()" class="cursor-pointer" target="_blank"><u>คลิกที่นี่</u></a></p>
                                </div>

                                <vs-input type="text" label-placeholder="เลขประจําตัวประชาชน" v-model="form.idCardNumber" class="w-full mb-8" />
                                <vs-button type="border" to="/user/login" class="px-4 w-full md:w-auto">{{ $t('views.user.reset-password.btnGoback') }}</vs-button>
                                <vs-button
                                 class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                                 :disabled="disabledSubmit"
                                 @click="onForgotPasswordClick()">{{ $t('views.user.reset-password.btnSubmit') }}</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
const BASE_URL = process.env.BASE_URL || "/";

import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      form:{
        idCardNumber: ""
      }
    }
  },
  computed: {
    ...mapState(['status']),
    disabledSubmit() {
      const idCardNumber = this.form.idCardNumber.trim()
      return idCardNumber.length !== 13
    },
  },
  methods: {
    ...mapActions(['forgotPassword']),
    onDownloadFormResetEmailClick() {
      const path = BASE_URL + 'static/pdf/ใบคำขอเปลี่ยนแปลงข้อมูล.pdf'
      window.open(path, '_blank');
    },
    async onForgotPasswordClick () {
      const vm = this
      const {result, msg} = await vm.forgotPassword({
        credential: {
          idCardNumber: vm.form.idCardNumber
        }
      })
      if(result){
        Swal.fire({
          title: 'Success!',
          text: msg,
          icon: 'success',
          confirmButtonText: 'ตกลง'
        })
      }else{
        Swal.fire({
          title: 'Error!',
          text: msg,
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
      }
    }
  },
  watch: {
    'status.processing'(val) {
      if(val){
        this.$vs.loading();
      }else{
        this.$vs.loading.close();
      }
    }
  }
}
</script>
